import type { RecordOf } from 'immutable';

import * as types from './reportConfigurationsTypes';

export function transformReportConfigurationToRequestData(
  reportConfiguration: types.ReportConfiguration | types.ReportConfigurationProps,
) {
  return {
    id: reportConfiguration.id,
    clientId: reportConfiguration.clientId,

    name: reportConfiguration.name,
    description: reportConfiguration.description,

    accountingType: reportConfiguration.accountingType,
    reportType: reportConfiguration.reportType,
    reportSubType: reportConfiguration.reportSubType,
    persistentType: reportConfiguration.persistentType,

    dateRange: reportConfiguration.dateRange,
    startOn: reportConfiguration.startOn,
    endOn: reportConfiguration.endOn,

    columnType: reportConfiguration.columnType,
    rowType: reportConfiguration.rowType,
    timestep: reportConfiguration.timestep,

    showTotalRows: reportConfiguration.showTotalRows,

    filterId: reportConfiguration.filterId,
    filter: reportConfiguration.filter,

    isDeleted: reportConfiguration.isDeleted,
  };
}

type RequestDataArray = Array<ReturnType<typeof transformReportConfigurationToRequestData>>;

export function transformReportConfigurationsToRequestData(
  resourceConfigurations: Array<types.ReportConfiguration | types.ReportConfigurationProps>,
) {
  const resources = resourceConfigurations.reduce<RequestDataArray>((list, resourceConfiguration) => {
    list.push(transformReportConfigurationToRequestData(resourceConfiguration));
    return list;
  }, []);

  return {
    resources,
  };
}

export function transformResponseToReportConfigurations(
  response?: { data?: { resources?: types.ReportConfigurationProps[] } } | null,
): RecordOf<types.ReportConfigurationProps>[] | null | undefined {
  return response?.data?.resources?.map((data) =>
    types.mkReportConfiguration({
      id: data.id,
      clientId: data.clientId,

      name: data.name,
      description: data.description,

      accountingType: data.accountingType,
      reportType: data.reportType,
      reportSubType: data.reportSubType,
      persistentType: data.persistentType,

      dateRange: data.dateRange,

      columnType: data.columnType,
      rowType: data.rowType,
      timestep: data.timestep,

      filterId: data.filterId,

      isDeleted: data.isDeleted,
      modifiedAt: data.modifiedAt,
    }),
  );
}
